module.exports = __webpack_public_path__ + "img/ResponsiveDisplayAds.2c7b9789.svg";